import { inject, Injectable, signal } from '@angular/core';
import { IConstantes } from '../interfaces/app.inteface';
import { API_URL } from '../constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  constantes = signal<IConstantes | null>(null);
  private apiURL: string = `${API_URL}/constantes/`;

  private http = inject(HttpClient);

  getConstants(): Observable<IConstantes> {
    return this.http.get<IConstantes>(this.apiURL);
  }

}
